import { FormatVO as BaseFormatVO, IVo, entity, field } from '@wizeoo/akm-compute-lib';
import { Format, TranslatedEmb } from '@wizeoo/akm-message-lib';
import { TranslatableLabelVO } from '../../vo/common/translation/translatable-label.vo';
import { Model } from '../../model/model';
/**
 * VO représentant un format de mesure
 */
@entity('wizeoo.allkeyme.workingdata.message.Format', 'BU')
export class FormatVO extends BaseFormatVO implements IVo {
  
  constructor(model: Model, pSource?: Format) {
    super(pSource);
    this._model = model; 
  }

  protected _model: Model = null;
  protected get model(): Model {
    return this._model as Model;
  }
  protected set model(value: Model) {
      this._model = value;
  }
  

  @field('maintenanceFlag') // patch pour s'assurer de la demande de mise à jour sur contenu des lines
  public get maintenanceFlag(): string {
    return this.source.maintenanceFlag;
  }
  public set maintenanceFlag(value: string) {
    this.source.maintenanceFlag = value;
  }

  /**
   * code unique du format dans la bu
   */
  @field('string')
  public set code(value: string) {
    this.source.code = value;
  }
  public get code(): string {
    return this.source.code;
  }

  @field('string')
  public set shortCode(value: string) {
    this.source.shortCode = value;
  }
  public get shortCode(): string {
    return this.source.shortCode;
  }

  /** type de donnée */
  @field('string')
  public set dataKind(value: string) {
    this.source.dataKind = value;
  }
  public get dataKind(): string {
    return this.source.dataKind;
  }

  /**
   * expression pour rendu
   */
  @field('string')
  public set regExp(value: string) {
    this.source.regExp = value;
  }
  public get regExp(): string {
    return this.source.regExp;
  }

  // Id technique
  public get id(): number {
    return this.source.id;
  }
  public set id(value: number) {
    this.source.id = value;
  }

  // UID technique
  public get uid(): string {
    return this.source.uid;
  }
  public set uid(value: string) {
    this.source.uid = value;
  }

  public get version(): number {
    // technique
    return this.source.version;
  }
  public set version(value: number) {
    this.source.version = value;
  }

  @field('TranslatedEmb')
  public set label(value: TranslatedEmb) {
    this.source.label = value;
  }
  public get label(): TranslatedEmb {
    return this.source.label;
  }

  @field('TranslatedEmb')
  public set description(value: TranslatedEmb) {
    this.source.description = value;
  }
  public get description(): TranslatedEmb {
    return this.source.description;
  }

  /* ################################################
              gestion de la traduction
  ################################################ */

  /**
   * Return translated label
   * @return string
   */
  get trsLabel(): string {
    return this.model.localeEngine.translate(this.label, this.shortCode);
  }

  /**
   * Return translated label
   * @return string
   */
  get trsDescription(): string {
    return this.model.localeEngine.translate(this.description);
  }

  /** Libellé traductible */
  private _labelVO: TranslatableLabelVO;
  public get labelVO(): TranslatableLabelVO {
    if (!this._labelVO) {
      this._labelVO = this.model.localeEngine.newTranslatableVO(this, 'label');
    }
    return this._labelVO;
  }

  /** description en mode VO */
  private _descriptionVO: TranslatableLabelVO;
  public get descriptionVO(): TranslatableLabelVO {
    if (!this._descriptionVO) {
      this._descriptionVO = this.model.localeEngine.newTranslatableVO(this, 'description');
    }
    return this._descriptionVO;
  }

  /* ################################################
                    Accesseurs composites
  ################################################ */

  /** Le format est-il persisté? */
  public get exist(): boolean {
    // l'objet existe en BDD (id)
    return this.source.id > 0;
  }

}
